import React from 'react';
import styled from 'styled-components';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';

const getDisponibilidadeMotoristaBadgeVariant = value => (value === 'Disponivel' ? 'success' : 'danger');

const CompactBadge = ({ label, variant }) => (
  <CompactBadgeWrap title={label} $variant={variant}>
    {label}
  </CompactBadgeWrap>
);

export const getDisponibilidadeMotoristaColumns = () => [
  {
    id: 'motorista',
    header: 'Motorista',
    accessorKey: 'motorista',
    size: 180,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={16} />
  },
  {
    id: 'cpf',
    header: 'CPF',
    accessorKey: 'cpf',
    size: 152,
    enableSorting: true,
    cell: ({ getValue }) => <span>{getValue()}</span>
  },
  {
    id: 'gestor',
    header: 'Gestor',
    accessorKey: 'gestor',
    size: 170,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={18} />
  },
  {
    id: 'disponivel',
    header: 'Status',
    accessorKey: 'disponivelLabel',
    size: 120,
    enableSorting: true,
    cell: ({ getValue }) => <CompactBadge label={getValue()} variant={getDisponibilidadeMotoristaBadgeVariant(getValue())} />
  },
  {
    id: 'cidade',
    header: 'Cidade',
    accessorKey: 'cidade',
    size: 170,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={20} />
  },
  {
    id: 'estado',
    header: 'Estado - UF',
    accessorKey: 'estado',
    size: 122,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={2} />
  }
];

const CompactBadgeWrap = styled.span`
  display: inline-block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 3px 4px;
  box-sizing: border-box;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 0;
  font-size: 9px;
  font-weight: 600;
  line-height: 1.2;
  text-transform: uppercase;

  ${props => {
    switch (props.$variant) {
      case 'success':
        return `
          background-color: #d4edda;
          color: #155724;
          border: 1px solid #c3e6cb;
        `;

      case 'danger':
        return `
          background-color: #f8d7da;
          color: #721c24;
          border: 1px solid #f5c6cb;
        `;

      default:
        return `
          background-color: #e2e3e5;
          color: #383d41;
          border: 1px solid #d6d8db;
        `;
    }
  }}
`;
